import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import Button from '../../../components/Button';
import init from '../AccessControl/Check';
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';
import ShowPasswordClose from "./../../../assets/icons/show-password-icon-close.png";
import ShowPasswordOpen from "./../../../assets/icons/show-password-icon-open.png";
import { MAX_UPLOAD_FILE_SIZE } from "../../../components/Constants/FileUpload";

const UserCreation = () => {
    const pageName = "User Create";
    const isAccess = init(pageName);

    const navigate = useNavigate();

    const [roleList, setRoleList] = useState([]);

    const [input, setInput] = useState({
        name: "",
        email: "",
        password: "",
        mobileNo: "",
        photo: "",
        address: "",
        user_type: "",
    })
    const fileInput = useRef();
    const [file, setFile] = useState();
    const [mobileNumber, setMobileNumber] = useState('')

    const handleInputChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value });
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const inputNumberHandler = (event) => {
        const res = event.target.value.replace(/\D/g, '');
        setMobileNumber(res);
    }



    const submitFormData = (event) => {
        event.preventDefault();

        if (!isValidEmail(input.email)) {
            toast.error('Email is invalid');
            return;
        }

        if ((input.password.length < 3)) {
            toast.error("Password must contain at least 3 characters.");
            return;
        }

        // if (file === undefined) {
        //     toast.error("Please upload your photo !");
        //     return;
        // }

        $("button[type=submit]").attr("disabled", true);
        
        let requestBody = new FormData();

        requestBody.append("name", input.name);
        requestBody.append("email", input.email);
        requestBody.append("password", input.password);
        requestBody.append("mobile_no", mobileNumber);
        requestBody.append("photo", file);
        requestBody.append("address", input.address);
        requestBody.append("user_type", input.user_type);


        // Create a User
        PostLoginPostApi("registration", requestBody, 3, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("User added successfully.");
                    return navigate("/dashboard/user");
                }

                toast.error(responseData["messages"].toString() ?? responseData["message"].toString());
            }
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        }).finally(() => {
            $("button[type=submit]").attr("disabled", false);
            return;
        });

    }

    useEffect(() => {
        // Manage Role
        PostLoginGetApi("manage/role", "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setRoleList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);


    const selectFile = () => {
        fileInput.current.click();
    }

    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        } 

        
        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile(e.target.files[0]);
    }


    const showPassword = (id) => {
        $(".show-password-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-password-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-password-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <div className="font-medium pb-[60px]">
                <header className="flex justify-between items-center p-4 border-b-2 border-dark-white mb-[60px]">
                    <Link to="/dashboard/user"><CloseBtn /></Link>
                    <p className="text-xl text-black text-center">Register New User</p>
                    <div></div>
                </header>
                <main className="max-w-3xl m-auto mb-[60px]">
                    <div className="flex justify-center">
                        <form action='' autoComplete="off" method='POST' className="w-full" onSubmit={(event) => submitFormData(event)} >

                            <h3 className="text-xl mb-[15px]">Create User</h3>

                            <div className="relative py-2 mb-1">
                                <input type="text" name="name" id="name" value={input.name} onChange={handleInputChange} title="name" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="name" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Name *</label>
                            </div>


                            <div className="relative pb-2 pt-1 mb-1">
                                <input type="email" name="email" id="email" value={input.email} onChange={handleInputChange} title="Email" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="email" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Email *</label>
                            </div>


                            <div className="flex">
                                <div className="relative py-1 mb-1 w-1/2">
                                    <input type="password" autoComplete="new-password" name="password" id="password" value={input.password} onChange={handleInputChange} title="Password" minLength={8} maxLength={20} placeholder=" " className="block w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                    <label htmlFor="password" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Password *</label>

                                    <img alt="Show Password" className="show-password-icon" src={ShowPasswordOpen} onClick={() => showPassword("password")} style={{ paddingTop: "7px", paddingRight: "5px" }}></img>
                                    <img alt="Show Password" style={{ display: "none", marginTop: "-29px", marginRight: "12px" }} className="show-password-icon" src={ShowPasswordClose} onClick={() => showPassword("password")}></img>
                                </div>
                                <div className="relative py-1 mb-1 w-1/2 pt-3.5 pl-3 text-md">
                                    <i>Password must be 8-20 characters long</i> 
                                </div>
                            </div>

                            <div className="relative pb-2 pt-1 mb-1">
                                <input type="text" name="address" id="address" value={input.address} onChange={handleInputChange} title="Address" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="address" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Address *</label>
                            </div>

                            <div className="relative pb-2 pt-1 mb-1">
                                <input type="tel" name="mobileNo" id="mobileNo" value={mobileNumber} onChange={inputNumberHandler} minLength={11} maxLength={11} title="Mobile Number" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="mobileNo" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Mobile Number *</label>
                            </div>

                            <div className="flex pb-2 pt-1 mb-1 items-center">
                                <div className="flex items-center relative w-1/2 bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                                    <input type="file" name="photo" className="hidden" ref={fileInput} onChange={handleChange} />
                                    <label htmlFor="photo" className="p-1 text-base font-medium">Upload Photo</label>

                                    {file ?
                                        <>
                                            {file["type"].includes("image/") ? <img src={URL.createObjectURL(file)} alt="Preview Trade License" className="max-h-10 max-w-10 ml-auto order-3" /> : <span className="text-xs pr-3">{file["name"]}</span>}
                                            <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change Photo</button>
                                        </> :
                                        <>
                                            <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Upload</button>
                                        </>
                                    }
                                </div>
                            </div>

                            <div className="py-2 mt-1 relative mb-3">
                                <select name="user_type" id="user-type" value={input.user_type} onChange={handleInputChange} className="w-full rounded border-solid border border-dark-white" required>
                                    <option value="" hidden>Role Type *</option>
                                    {roleList.map((data, index) => (
                                        <option key={index} value={data.id} className='text-black'>
                                        {
                                            (data.name === "User") ? 
                                            <>User - KAM</>
                                            :
                                            <>{(data.name === "Owner") ? 
                                                <>User - POC</>
                                                :
                                                <>{data.name}</>
                                            } 
                                            </>
                                        }
                                        </option>
                                    ))}
                                </select>
                            </div>



                            <Button name="Submit"></Button>
                        </form>
                    </div>
                </main>
            </div>

            <style>{`
				* :disabled {
					background-color: #F5F5F5 !important;
				}

			`}</style>

        </div>
    );
};

export default UserCreation;